import { PageData } from '@/api/content/models';

export const pageCache = new Map<string, PageData>();
